import React from 'react';
import { Transition, TransitionGroup } from 'react-transition-group';

/**
 * material ui
 */
import { useScrollTrigger, Zoom, makeStyles, Fab } from '@material-ui/core';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

/**
 * components
 */
import Header from '../components/header';
import Header2 from '../components/digital-media/Header';

import Footer from '../components/footer';
import GlobalStyles from '../components/GlobalStyles';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    paddingTop: '85px',
  },
  root: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));

/**
 * top bar
 */
function ScrollTop(props) {
  const { children, window } = props;
  const classes = useStyles();

  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      '#back-to-top-anchor',
    );

    if (anchor) {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <Zoom in={trigger}>
      <div onClick={handleClick} role="presentation" className={classes.root}>
        {children}
      </div>
    </Zoom>
  );
}

const Layout = ({ children }) => {
  return (
    <>
      <GlobalStyles />
      <div id="back-to-top-anchor"></div>
      {typeof window !== 'undefined' && window.location.pathname === '/' ? (
        <Header />
      ) : (
        <Header2 />
      )}
      {children}
      <Footer />

      <ScrollTop {...children}>
        <Fab color="default" size="medium" aria-label="scroll back to top">
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>
    </>
  );
};

export default Layout;
